import { clsx } from 'clsx';
import { Input, Select } from 'antd';
import { CSSProperties, useEffect, useState } from 'react';

import cls from './SelectedPhoneInput.module.css';


interface Props {
  name: string;
  value: string | null;
  onChange: (value: string) => void;
  options?: {label: string; value: string;}[];
  placeholder?: string;
  className?: string;
  maxLength?: number;
  label?: string;
  labelWidth?: number;
}

const { Option } = Select;
const defaultOptions = [
  { label: '+52', value: '+52' },
  { label: '+1', value: '+1' },
];
const defaultLength = 10;

export const SelectedPhoneInput = ({
  options = defaultOptions,
  placeholder,
  value,
  onChange,
  maxLength = defaultLength,
  className,
  label,
  name,
  labelWidth,
}: Props) => {
  const splitPhone = (phone: string): [string, string] => {
    if (!phone.trim() || phone.trim().length < 12) {
      return [options[0].value, ''];
    }
    const number = phone.slice(-10);
    const prefix = phone.slice(0, -10);

    return [prefix, number];
  };

  const [prefix, setPrefix] = useState(value ? splitPhone(value)[0] : '');
  const [num, setNum] = useState(value ? splitPhone(value)[1] : '');

  const handleChange = (val: string) => {
    const onlyNumbers = val.replace(/\D/g, '');
    setNum(onlyNumbers);
  };

  useEffect(() => {
    onChange(prefix + num);
  }, [num, prefix]);

  return (
    <div className={clsx(cls.wrap, className)}>
      {label ? (
        <label
          className={cls.label}
          htmlFor={name}
          style={{ '--label-width': `${labelWidth || 100}px` } as CSSProperties}
        >{label}</label>
      ) : null}

      <Input.Group compact className={cls.field}>
        <Select
          defaultValue={options[0].value}
          value={prefix}
          onChange={setPrefix}
          className={cls.select}
        >
          {options.map((o) => (
            <Option key={o.value} value={o.value}>{o.label}</Option>
          ))}
        </Select>
        <Input
          id={name}
          placeholder={placeholder}
          value={num}
          onChange={e => handleChange(e.target.value)}
          maxLength={maxLength}
          className={cls.input}
        />
      </Input.Group>
    </div>
  );
};
